import { render, staticRenderFns } from "./inclusionSidebar.vue?vue&type=template&id=c87b5d18&scoped=true&"
import script from "./inclusionSidebar.vue?vue&type=script&lang=js&"
export * from "./inclusionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./inclusionSidebar.vue?vue&type=style&index=0&id=c87b5d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b5d18",
  null
  
)

export default component.exports